import { signal, WritableSignal } from "@angular/core";
import { ProblemDetailsModel } from "../models/problem-details";
import { ToastMessageService } from "../services/toast-message.service";

export function handleValidationErrors(err: any, problems: WritableSignal<ProblemDetailsModel | null> | null = null, toast?: ToastMessageService) {
    if (!problems)
        problems = signal<ProblemDetailsModel | null>(null);

    if (err.status === 400 && err.error && err.error.errors) {
        const problemDetails = err.error as ProblemDetailsModel;
        problemDetails.senderName = err.senderName;
        problems.set(problemDetails);
        return problems();
    } else {
        if (err.status === 429) {
            if (err.error) {
                const problemDetails: ProblemDetailsModel = { errors: { Name: [err.error] }, status: 429, detail: err.error };
                problems.set(problemDetails);
            }
            else {
                toast?.showWarning('Han habido demasiados intentos. Intente nuevamente más tarde.');
            }
        }
        else {
            err.status = 0
            throw err;
        }

        return problems();
    }
}

export function getValidationErrors(err: any): ProblemDetailsModel | null {
    if (err.status === 400 && err.error && err.error.errors) {
        return err.error as ProblemDetailsModel;
    }
    return null;
}

export function isNotFound(err: any) {
    if (err.status === 404) {
        return true;
    }

    return false;
}
export function isUnauthorized(err: any) {
    if (err.status === 401) {
        return true;
    }

    return false;
}

export function isBadRequest(err: any) {
    if (err.status === 400) {
        return true;
    }

    return false;
}